const MEReportingRoutes = [
  //   {
  //     path: '/login',
  //     name: 'Login',
  //     component: Login,
  //   },
];

export default MEReportingRoutes;
